module.exports = __webpack_public_path__ + "static/img/A120.ae523804.jpg";